/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from 'angular-io-overlay/src/overlay/overlayComponent';
const styles_OverlayComponent:any[] = ['[_nghost-%COMP%] {\n          position: absolute;\n          z-index: 100;\n        }\n\n        .fixed[_nghost-%COMP%] {\n          position: fixed;\n        }'];
export const RenderType_OverlayComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:0,
    styles:styles_OverlayComponent,data:{}});
function View_OverlayComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵand(0,(null as any),(null as any),0))],(null as any),
      (null as any));
}
export function View_OverlayComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵand(0,[['container',2]],(null as any),0,(null as any),
      View_OverlayComponent_1))],(null as any),(null as any));
}
export function View_OverlayComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'overlay',([] as any[]),
      [[2,'fixed',(null as any)],[4,'left','px'],[4,'top','px']],(null as any),(null as any),
      View_OverlayComponent_0,RenderType_OverlayComponent)),i0.ɵdid(1,114688,(null as any),
      0,i1.OverlayComponent,[i0.ComponentFactoryResolver,i0.ElementRef],(null as any),
      (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,1).positionFixed;
    const currVal_1:any = i0.ɵnov(_v,1).left;
    const currVal_2:any = i0.ɵnov(_v,1).top;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
export const OverlayComponentNgFactory:i0.ComponentFactory<i1.OverlayComponent> = i0.ɵccf('overlay',
    i1.OverlayComponent,View_OverlayComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2NvZGVidWlsZC9vdXRwdXQvc3JjNDA3ODE3ODE1NS9zcmMvbm9kZV9tb2R1bGVzL2FuZ3VsYXItaW8tb3ZlcmxheS9zcmMvb3ZlcmxheS9vdmVybGF5Q29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2NvZGVidWlsZC9vdXRwdXQvc3JjNDA3ODE3ODE1NS9zcmMvbm9kZV9tb2R1bGVzL2FuZ3VsYXItaW8tb3ZlcmxheS9zcmMvb3ZlcmxheS9vdmVybGF5Q29tcG9uZW50LmQudHMiLCJuZzovLy9jb2RlYnVpbGQvb3V0cHV0L3NyYzQwNzgxNzgxNTUvc3JjL25vZGVfbW9kdWxlcy9hbmd1bGFyLWlvLW92ZXJsYXkvc3JjL292ZXJsYXkvb3ZlcmxheUNvbXBvbmVudC5kLnRzLk92ZXJsYXlDb21wb25lbnQuaHRtbCIsIm5nOi8vL2NvZGVidWlsZC9vdXRwdXQvc3JjNDA3ODE3ODE1NS9zcmMvbm9kZV9tb2R1bGVzL2FuZ3VsYXItaW8tb3ZlcmxheS9zcmMvb3ZlcmxheS9vdmVybGF5Q29tcG9uZW50LmQudHMuT3ZlcmxheUNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjx0ZW1wbGF0ZSAjY29udGFpbmVyPjwvdGVtcGxhdGU+IiwiPG92ZXJsYXk+PC9vdmVybGF5PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBOzs7b0JDQUE7TUFBQTt5REFBQSxVQUFBO01BQUE7TUFBQTtJQUFBOztJQUFBO0lBQUE7SUFBQTtJQUFBLFdBQUEsNkJBQUE7Ozs7In0=



// WEBPACK FOOTER //
// /codebuild/output/src4078178155/src/src/$$_gendir/~/angular-io-overlay/src/overlay/overlayComponent.ngfactory.ts